import LeadsContainer from "../../container/admin/leads";

const Leads = () => {
    return <LeadsContainer />;
};

export default Leads;